import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { searchProducts } from "../../../services/product";
import ProductCard from "../../../features/adminDashboard/products/utils/ProductCard";
import Loading from "../../../utils/LoadingIndicator/Loading";
import Pagination from "../../../features/adminDashboard/products/utils/Pagination";
import { useQuery } from "@tanstack/react-query";

const SearchResults = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("q");
  const [page, setPage] = useState(1);
  const limit = 8;

  const {
    data: searchData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["search", query, page],
    queryFn: () => searchProducts(query, page, limit),
    enabled: !!query,
  });

  // Scroll to top when search query changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [query]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <h2 className="text-red-500 text-xl">{error.message}</h2>
      </div>
    );
  }

  const { data: products = [], pagination } = searchData || {};

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-gray-800">
        Search Results for "{query}"
      </h1>
      {products.length === 0 ? (
        <div className="text-center text-gray-600 py-8">
          No products found matching your search.
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
          {pagination && pagination.totalPages > 1 && (
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SearchResults;
